import { mapDateToSimpleDate } from './mapDateToSimpleDate';

export function mapStringToSimpleDate(data: string | null) {
  if (!data) {
    return null;
  }
  const date = new Date(data);
  return mapDateToSimpleDate(date);
}
